import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  User, 
  Building2, 
  Mail, 
  Lock, 
  Eye, 
  EyeOff, 
  CheckCircle, 
  AlertCircle,
  ArrowRight,
  GraduationCap,
  Users
} from 'lucide-react';
import { authService } from '../../services/auth.service';
import logo from '../../assets/logo.png';

type AuthMode = 'login' | 'register';
type UserRole = 'trainee' | 'training_center';

interface FormData {
  email: string;
  password: string;
  confirmPassword?: string;
  firstName?: string;
  lastName?: string;
  centerName?: string;
  phone?: string;
}

const AuthPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Redirect to role selection page as the new entry point
  useEffect(() => {
    navigate('/auth/role-selection', { replace: true });
  }, [navigate]);

  // Loading component while redirecting
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-surface via-white to-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-brand-primary/30 border-t-brand-primary rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">{t('auth.redirecting', 'Redirecting...')}</p>
      </div>
    </div>
  );
};

export default AuthPage;
